'use client';

import { useEffect } from 'react';
import { addReactError } from '@datadog/browser-rum-react';
import NextError from 'next/error';

import { isDatadogEnabled } from 'lib/datadog';
import Sentry from 'utils/sentry';

export default function GlobalError({ error }: { error: Error & { digest?: string } }): React.ReactElement {
  useEffect(() => {
    Sentry.captureException(error);
    if (isDatadogEnabled) {
      addReactError(error, {});
    }
  }, [error]);

  return (
    <html>
      <body>
        {/* `NextError` is the default Next.js error page component. Its type
        definition requires a `statusCode` prop. However, since the App Router
        does not expose status codes for errors, we simply pass 0 to render a
        generic error message. */}
        <NextError statusCode={0} />
      </body>
    </html>
  );
}
